import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import GuidesPage from './pages/GuidesPage';
import ChoosingRightCasino from './pages/guides/ChoosingRightCasino';
import UnderstandingWelcomeBonuses from './pages/guides/UnderstandingWelcomeBonuses';
import WageringRequirementsExplained from './pages/guides/WageringRequirementsExplained';
import PaymentMethodsGuide from './pages/guides/PaymentMethodsGuide';
import ResponsibleGambling from './pages/guides/ResponsibleGambling';
import SlotGameStrategies from './pages/guides/SlotGameStrategies';
import TableGamesGuide from './pages/guides/TableGamesGuide';
import WithdrawalProcess from './pages/guides/WithdrawalProcess';
import CasinoSecurityLicensing from './pages/guides/CasinoSecurityLicensing';
import NewsPage from './pages/NewsPage';
import UKGamblingRegulations from './pages/news/UKGamblingRegulations';
import TopSlotGames from './pages/news/TopSlotGames';
import CryptocurrencyPayments from './pages/news/CryptocurrencyPayments';
import LiveCasinoTrends from './pages/news/LiveCasinoTrends';
import BonusTransparency from './pages/news/BonusTransparency';
import MobileGamingGrowth from './pages/news/MobileGamingGrowth';
import ResponsibleGamblingTools from './pages/news/ResponsibleGamblingTools';
import PaymentSpeedImprovements from './pages/news/PaymentSpeedImprovements';
import GameProviderPartnerships from './pages/news/GameProviderPartnerships';
import ReviewsPage from './pages/ReviewsPage';
import CasinoCasinoReview from './pages/reviews/CasinoCasinoReview';
import MagicRedReview from './pages/reviews/MagicRedReview';
import AllBritishCasinoReview from './pages/reviews/AllBritishCasinoReview';
import SlotsPage from './pages/SlotsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <>
        <ScrollToTop />
        <AgeVerification />
        <CookieConsent />
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/choosing-right-casino" element={<ChoosingRightCasino />} />
        <Route path="/guides/understanding-welcome-bonuses" element={<UnderstandingWelcomeBonuses />} />
        <Route path="/guides/wagering-requirements-explained" element={<WageringRequirementsExplained />} />
        <Route path="/guides/payment-methods-guide" element={<PaymentMethodsGuide />} />
        <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
        <Route path="/guides/slot-game-strategies" element={<SlotGameStrategies />} />
        <Route path="/guides/table-games-guide" element={<TableGamesGuide />} />
        <Route path="/guides/withdrawal-process" element={<WithdrawalProcess />} />
        <Route path="/guides/casino-security-licensing" element={<CasinoSecurityLicensing />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/uk-gambling-regulations" element={<UKGamblingRegulations />} />
        <Route path="/news/top-slot-games" element={<TopSlotGames />} />
        <Route path="/news/cryptocurrency-payments" element={<CryptocurrencyPayments />} />
        <Route path="/news/live-casino-trends" element={<LiveCasinoTrends />} />
        <Route path="/news/bonus-transparency" element={<BonusTransparency />} />
        <Route path="/news/mobile-gaming-growth" element={<MobileGamingGrowth />} />
        <Route path="/news/responsible-gambling-tools" element={<ResponsibleGamblingTools />} />
        <Route path="/news/payment-speed-improvements" element={<PaymentSpeedImprovements />} />
        <Route path="/news/game-provider-partnerships" element={<GameProviderPartnerships />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/reviews/casino-casino" element={<CasinoCasinoReview />} />
        <Route path="/reviews/magic-red" element={<MagicRedReview />} />
        <Route path="/reviews/all-british-casino" element={<AllBritishCasinoReview />} />
        <Route path="/slots" element={<SlotsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/contact" element={<Home />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
